import React, { useState, useEffect } from 'react';
import api from '../api';
import { ensureGuid } from '../utils/id';
import { validateVendor, hasErrors } from '../utils/validation';

function Vendors(){
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({id:'', name:'', contactName:'', email:'', phone:'', address:'', isActive: true, createdDatetime: ''});
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState('');
  const [attempted, setAttempted] = useState(false);

  const errors = validateVendor(form);
  const isValid = !hasErrors(errors);

  async function load(){
    setLoading(true);
    setError(null);
    setMessage('');
    try{
      const data = await api.list('vendors');
      setItems(Array.isArray(data)?data:[]);
    }catch(e){
      console.error('load vendors', e);
      setError(e.message || String(e));
      setItems([]);
    }finally{
      setLoading(false);
    }
  }

  useEffect(()=>{ load(); },[]);

  async function save(){
    if(!isValid){
      setAttempted(true);
      return;
    }
    setSaving(true);
    setError(null);
    setMessage('');
    try{
      const payload = { ...form, id: ensureGuid(form.id), tableId: 'Vendor', createdDatetime: form.createdDatetime || new Date().toISOString() };
      if(form.id) await api.update('vendors', form.id, payload);
      else await api.create('vendors', payload);
      await load();
      setForm({id:'',name:'',contactName:'',email:'',phone:'',address:'',isActive:true, createdDatetime: ''});
      setMessage('保存成功');
      setAttempted(false);
    }catch(e){
      console.error(e);
      setError(e.message || String(e));
    }finally{
      setSaving(false);
    }
  }

  function edit(it){ setForm({
    id: it.id || '',
    name: it.name || '',
    contactName: it.contactName || '',
    email: it.email || '',
    phone: it.phone || '',
    address: it.address || '',
    isActive: it.isActive !== undefined ? it.isActive : true,
    createdDatetime: it.createdDatetime || ''
  }); }

  async function removeItem(id){ try{ await api.remove('vendors', id); await load(); }catch(e){console.error(e);} }
  async function confirmRemove(id){ if(window.confirm('Delete this vendor?')) await removeItem(id); }

  return (
    <div className="page">
      <aside className="card">
        <h3>供应商</h3>
        {error && <div className="alert error">{error}</div>}
        {message && <div className="alert info">{message}</div>}
        <div className="form-row"><label>供应商名</label><input className={attempted && errors.name ? 'invalid' : ''} value={form.name} onChange={e=>setForm({...form,name:e.target.value})} />{attempted && errors.name && <div className="field-error">{errors.name}</div>}</div>
        <div className="form-row"><label>联系人</label><input value={form.contactName} onChange={e=>setForm({...form,contactName:e.target.value})} /></div>
        <div className="form-row"><label>电子邮件</label><input className={attempted && errors.email ? 'invalid' : ''} type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} />{attempted && errors.email && <div className="field-error">{errors.email}</div>}</div>
        <div className="form-row"><label>电话</label><input className={attempted && errors.phone ? 'invalid' : ''} type="tel" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} />{attempted && errors.phone && <div className="field-error">{errors.phone}</div>}</div>
        <div className="form-row"><label>地址</label><input value={form.address} onChange={e=>setForm({...form,address:e.target.value})} /></div>
        <div className="form-row"><label>是否启用</label><input type="checkbox" checked={form.isActive} onChange={e=>setForm({...form,isActive: e.target.checked})} /></div>
        {/* 创建时间字段已隐藏 */}
        <div style={{display:'flex',gap:8}}>
          <button className="btn" onClick={save} disabled={saving || loading}>{saving? '保存中...' : '保存'}</button>
          <button className="btn secondary" onClick={()=>{ setForm({id:'',name:'',contactName:'',email:'',phone:'',address:'',isActive:true, createdDatetime: ''}); setMessage(''); setError(null); setAttempted(false); }}>重置</button>
        </div>
      </aside>
      <section className="card list" style={{overflowX:'auto'}}>
        <h3>供应商列表</h3>
        {loading ? <div>Loading...</div> : (
        <table style={{minWidth:600}}>
          <thead><tr><th>名称</th><th>联系人</th><th>电子邮件</th><th>电话</th><th>是否启用</th><th></th></tr></thead>
          <tbody>
            {items.map(it=> (
              <tr key={it.id}><td>{it.name}</td><td>{it.contactName}</td><td>{it.email}</td><td>{it.phone}</td><td>{String(it.isActive)}</td>
                <td className="actions"><button className="btn ghost" onClick={()=>edit(it)}>编辑</button>
                <button className="btn secondary" onClick={()=>confirmRemove(it.id)}>删除</button></td></tr>
            ))}
            {items.length===0 && <tr><td colSpan="6">暂无供应商</td></tr>}
          </tbody>
        </table>)}
      </section>
    </div>
  );
}

export default Vendors;
